import React, { PureComponent } from 'react';

import Button from 'widgets/Button';

export default class FoodProfileFailed extends PureComponent {
  render() {
    return (
      <div className="js-foodProfilePopup__failed">
        <div className="js-foodProfilePopup__headerBar">
          <h3>Connection error</h3>
          <Button
            className="js-createFoodProfileClose"
            onClick={this.props.closeHandler}
          />
        </div>
        <img src="/webshop/static/images/components/foodProfile/RHS_lychee.jpg" alt="" />
        <p>
          Sorry, we couldn’t connect to our Food Profile database just now,
          so we aren’t able to provide accurate dietary information right now.
        </p>
        <p>
          Please refresh the page and things should go back to normal.
        </p>
        <div className="js-foodProfilePopup__actionBar">
          <a href="https://www.foodmaestro.me/">Powered by Foodmaestro</a>
          <Button onClick={this.props.closeHandler}>OK</Button>
        </div>
      </div>
    );
  }
}
